import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux'

import HintWrapper from "../../components/HintWrapper";
import {domainInputChange, toggleHideDomainsGone} from "../../actions/Domain";

class DomainInput extends Component {

    constructor(props) {
        super(props);

        this.inputRef = React.createRef();
    }

    static propTypes = {
        domainInput: PropTypes.string,
        domainInputValid: PropTypes.bool.isRequired,
        onDomainInputChange: PropTypes.func.isRequired,
        onFormSubmit: PropTypes.func.isRequired
    }

    handleDomainCheckSubmit = (event) => {
        event.preventDefault()
        this.props.onFormSubmit()
    }

    focusInput = (event) => {
        if (this.inputRef && this.inputRef.current) {
            this.inputRef.current.focus();
        }
    }

    render() {

        return (
            <div className="domain-step__input">
                <h2>Wunschdomain prüfen</h2>
                <HintWrapper
                    theme="blue"
                    content={"Hier kannst du eine Domain für dein Projekt prüfen und zugleich bestellen. Du weißt noch nicht, wie deine Domain heißen soll? Dann kannst du deine Wunschdomain auch später im Kundencenter hinzubuchen."}
                />
                <form disabled={(!this.props.topLevelDomainsReady)} onSubmit={this.handleDomainCheckSubmit}>
                    <div className="labeled-input">
                        <label>Deine Wunschdomain</label>
                        <input ref={this.inputRef} id="domaincheck-input" onChange={(e) => {
                            this.props.onDomainInputChange(e.target.value)
                        }} type="text" placeholder="meinedomain.de" autoComplete="off" value={this.props.domainInput}/>
                    </div>
                    {(!this.props.domainInputValid || !this.props.topLevelDomainsReady) ? <div onClick={this.focusInput} className="domain-step__input__submit disabled">Prüfen</div> : <button type="button" onClick={this.handleDomainCheckSubmit} className="domain-step__input__submit">Prüfen</button>}
                </form>
                {this.props.domainsGone &&
                this.props.domainsGone[this.props.queriedDomain] &&
                this.props.domainsGone[this.props.queriedDomain].length > 0 ?
                    <a href={"#"} onClick={this.props.onHideDomainsGoneClick}>{this.props.hideDomainsGone ? 'Vergebene Domains anzeigen' : 'Vergebene Domains ausblenden'}</a> : null}
            </div>
        )
    }

}

const mapStateToProps = (state) => {

    return {
        domainInput: state.domainCheck.domainInput,
        topLevelDomainsReady: state.domainCheck.topLevelDomains.order.length > 0,
        domainInputValid: state.domainCheck.domainInput !== "",
        domainsGone: state.domainCheck.domainsGone,
        queriedDomain: state.domainCheck.queriedDomain,
        hideDomainsGone: state.domainCheck.hideDomainsGone
    }

}


const mapDispatchToProps = (dispatch, getState) => {

    return {
        onDomainInputChange: (value) => {
            dispatch(domainInputChange(value))
        },
        onHideDomainsGoneClick: (e) => {
            e.preventDefault()
            dispatch(toggleHideDomainsGone())
        }
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(DomainInput)



/** WEBPACK FOOTER **
 ** ./src/containers/domainstep/DomainInput.js
 **/